// src/slices/authSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {},
  accessToken: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setStoreDetails(state, action) {
      state.userInfo = { ...state.userInfo, ...action.payload };
    },
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload;
    },
    setAccessGranted: (state, action) => {
      state.userInfo.is_access_granted = action.payload;
    },
    clearStore(state) {
      state.userInfo = {};
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
});

export const { setStoreDetails, setAccessToken, setRefreshToken, setAccessGranted, clearStore } = authSlice.actions;
export default authSlice.reducer; // **Export the reducer function**
